import { useContext } from 'react'

import { AuthContext } from '../AuthProvider/context'

export const useAuth = () => ({ auth: useContext(AuthContext) })
